import React, { Component } from 'react';
import Head from 'next/head';
import Image from 'next/image';
import ContactForm from '../components/Form/contactForm';

class ContactUs extends Component {
  render() {
    return (
      <>
        <Head>
          <meta
            name="keywords"
            content="Hidream讯梦国际联系方式电话地址，易赛诺联系方式电话地址"
          />
          <meta
            name="description"
            content="Hidream讯梦国际总部在浙江杭州，如需市场合作、商务合作，可随时联系我们。"
          />
        </Head>

        <div id="contactus" className="contactus">
          <div className="banner">
            <Image
              src={require('../public/images/banner-6.jpg').default}
              alt="联系我们"
              layout="responsive"
              priority
            />
          </div>

          <div className="header">
            <div className="section_header_2">
              <h3>
                <svg className="icon" aria-hidden="true">
                  <use xlinkHref="#icon-hidream-mtitle-bg"></use>
                </svg>
                <span>联系我们</span>
              </h3>
              <p>留下你的联系方式，将由我们专业的营销顾问为你服务。</p>
            </div>
          </div>

          <div className="form">
            <ContactForm />
          </div>

          <div className="information">
            <div className="chahua">
              <Image
                src={require('../public/images/信件插画.png').default}
                alt="信件插画"
              />
            </div>

            <div className="item-wrapper">
              {/* <div className="item">
                <div className="title">
                  <span>XUN MENG INTERNATIONAL LIMITED</span>
                </div>
                <div className="email">E-mail：finance@hidream.net</div>
              </div> */}

              <div className="item">
                <div className="title">
                  <svg className="icon" aria-hidden="true">
                    <use xlinkHref="#icon-hidream-mjiaruwomen2"></use>
                  </svg>
                  <span>加入我们</span>
                </div>
                <div className="email">E-mail：zhouyujie@Hidream.net</div>
              </div>

              {/* <div className="item">
                <div className="title">
                  <svg className="icon" aria-hidden="true">
                    <use xlinkHref="#icon-hidream-mshichanghezuo2"></use>
                  </svg>
                  <span>市场合作</span>
                </div>
                <div className="email">E-mail：wangrui@Hidream.net</div>
              </div> */}

              <div className="item">
                <div className="title">
                  <svg className="icon" aria-hidden="true">
                    <use xlinkHref="#icon-hidream-mshangwuhezuo2"></use>
                  </svg>
                  <span>商务合作</span>
                </div>
                <div className="email">E-mail：yeguanghui@Hidream.net</div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ContactUs;
